import { Grid, GridItem } from '@chakra-ui/react';
import { Global } from '@emotion/react';
import { ReactNode } from 'react';

import { WhiteLabelMenu } from '../navigation/WhiteLabelMenu';

type WhiteLabelWrapperProps = {
  children?: ReactNode;
};

export const WhiteLabelWrapper = ({
  children
}: WhiteLabelWrapperProps): JSX.Element => {
  return (
    <>
      <Global styles={`body { background-color: #F4F4F4; }`} />
      <Grid templateColumns="15vw calc( 85vw - 17px )">
        <GridItem>
          <WhiteLabelMenu />
        </GridItem>
        <GridItem>{children}</GridItem>
      </Grid>
    </>
  );
};
